import React from 'react';
import { MapPin, Building2, Quote } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const AboutSection = () => {
  const { t, language } = useLanguage();
  const en = language === 'en';
  const zh = language === 'zh';

  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left: Content */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-[2px] bg-[#C9A84C]" />
              <span className="text-[#C9A84C] font-semibold text-sm tracking-wider uppercase">
                {t('about.subtitle')}
              </span>
            </div>

            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-[#1A1F4B] mb-8">
              {t('about.title')}
            </h2>

            <div className="space-y-5 text-[#1F2937]">
              <p className="text-base leading-relaxed">{t('about.text1')}</p>
              <p className="text-base leading-relaxed">{t('about.text2')}</p>
              <p className="text-base leading-relaxed">{t('about.text3')}</p>
            </div>

            <div className="mt-8 p-6 bg-[#1A1F4B] border-l-4 border-[#C9A84C] flex items-start gap-4">
              <Quote className="w-6 h-6 text-[#C9A84C] flex-shrink-0 mt-0.5" />
              <p className="text-white font-heading text-lg italic leading-snug">
                {t('about.quote')}
              </p>
            </div>

            <div className="mt-6 p-6 bg-[#F9FAFB] border-l-4 border-[#C9A84C]">
              <div className="flex items-center gap-3 mb-3">
                <Building2 className="w-5 h-5 text-[#C9A84C]" />
                <span className="font-semibold text-[#1A1F4B]">{t('about.hq')}</span>
              </div>
              <div className="flex items-start gap-3 text-[#1F2937]/70">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                <span className="text-sm">{t('about.address')}</span>
              </div>
            </div>
          </div>

          {/* Right: Image */}
          <div className="relative">
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&q=80"
                alt="Business meeting"
                className="w-full h-[500px] object-cover"
                loading="lazy"
              />
              <div className="absolute -bottom-6 -right-6 w-full h-full border-4 border-[#C9A84C] -z-10" />
              <div className="absolute -bottom-8 -left-8 bg-[#1A1F4B] p-6 text-white shadow-xl">
                <div className="text-4xl font-heading font-bold text-[#C9A84C]">2026</div>
                <div className="text-sm text-white/70 mt-1">
                  {en ? 'Founded' : zh ? '创立' : 'Fundação'}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
